import { motion } from "framer-motion";

// Masked line-by-line reveal for hero headings
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-line-wrap">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </M>
  );
};

// Image clip reveal
export const ClipReveal = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial={{ clipPath: "inset(100% 0 0 0)" }}
    whileInView={{ clipPath: "inset(0% 0 0 0)" }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, ease: [0.65, 0, 0.35, 1], delay }}
  >
    {children}
  </motion.div>
);
